<template>
  <div>
    <!-- heading row -->
		<v-row class="mx-2 my-1">
			<v-col cols="12" md="6">
				<h2 class="text-left">Manage Enquiry Sources</h2>
			</v-col>

			<v-spacer></v-spacer>

			<v-col cols="12" md="3">
				<v-btn
					color="primary"
					@click="showSourceDialog = true"
				>
					Add New Source
				</v-btn>
			</v-col>
		</v-row>

    <v-row justify="center" class="my-1">
			<v-col cols="12" md="8" sm="8" align-self="center">
				<v-card>
					<v-data-table
						:items="sourceItems"
						:headers="sourceHeaders"
						disable-pagination
						hide-default-footer
						class="my-2"
					>
						<template v-slot:item.actions="{ item }">
							<div v-if="false">{{ item }}
              </div>
              <div class="responsive-icons">
                <v-icon 
                  size="26"
                  class="mr-2 blue--text text--darken-4"
                  @click="triggerEditSource(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon 
                  size="26"
                  class="mr-2 red--text text--darken-4"
                  @click="triggerDeleteSource(item)"	
                  :disabled="item.is_used"
                >
                  mdi-delete
                </v-icon>
							</div>
						</template>
					</v-data-table>
				</v-card>
			</v-col>
		</v-row>

    <v-dialog v-model="showSourceDialog" persistent max-width="550px">
			<v-card>
				<v-card-title class="justify-center">
					<h3> {{ !is_editing ? 'Add' : 'Edit' }} Source </h3>
					<v-btn icon absolute top right color="dark" @click="closeSourceDialog">
						<b>x</b>
					</v-btn>
				</v-card-title>

				<v-card-text>
					<v-form
						ref="form"
						v-model="submitForm"
						@submit.prevent="saveSource()"
					>
						<v-container fluid>
							<v-row justify="center">
								<!-- title field -->
								<v-col cols="12" md="11">
									<v-text-field
										outlined
										dense
										label="Source"
										class="rounded-input"
										:rules="[rules.required]"
										v-model="addEditSource.name"
									>
									</v-text-field>
								</v-col>
							</v-row>

							<v-row justify="center">
								<v-col>
									<!-- submit btn -->
									<v-btn
										color="primary"
										type="submit"
										v-model="submitForm"
										:disabled="isLoading || !submitForm"
									>
										<!-- @click="saveSource" -->
										Submit
									</v-btn>
								</v-col>
							</v-row>
						</v-container>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

    <DeleteConfirmationDialog
			title="Are you sure you want to delete this Source?"
			:visible="showDeleteConfirmation"
			@deleteObject="deleteSource"
		/>

		<!-- snackbar -->
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line>
			{{ snackbar.message }}
			<template v-slot:action="{ attrs }">
				<v-btn dark text v-bind="attrs" @click="snackbar.visible = false">
					Close
				</v-btn>
			</template>
		</v-snackbar>

  </div>
</template>

<script>
import api from "@api/index"
import { mapActions, mapGetters } from "vuex"
import endpoints from "@api/repository"
import Helper from "@utils/misc"
import moment from "moment"
// import AddEditSources from "@components/task/AddEditSources.vue"
import DeleteConfirmationDialog from '@components/widgets/dialogs/DeleteConfirmationDialog.vue'

export default {
  name: 'ManageEnquiries',
	
  components: {
		DeleteConfirmationDialog
	},
	
  props: [],
	
  data() {
		return {
      moment: moment,
			snackbar: {
				visible: false,
				message: "",
				color: "dark",
			},

      // Validation
      rules: {
        required: (v) => !!v || "Required",
      },

			sourceHeaders: [
				{
					text: "Name",
					value: "name",
					align: "center",
					sortable: true,
				},
				{
					text: "Actions",
					sortable: false,
					value: 'actions',
					align: 'center'
				},
			],

			sourceItems: [
				// { name: 'important'},
				// { name: 'urgent'},
				// { name: 'deadline'},
				// { name: 'plan'},
				// { name: 'work'},
			],

      showDeleteConfirmation: false,
      is_editing: false,
      selectedSource: null,

      submitForm: false,

      addEditSource: {
        name: null,
        institution: null
      },
			
      showSourceDialog: false,
    }
  },

  computed: {
		...mapGetters([
			"currentUser",
			"accessToken",
			"isLoading",
			"currentInstitution",
		]),

		apiEssentials() {
			return {
				accessToken: this.accessToken,
				setLoading: this.setLoading,
				handleErrorsFunction: this.handleApiErrors,
			};
		},
	},

	methods: {
		...mapActions(["setLoading"]),

		// handle api errors
		async handleApiErrors(err) {
			this.setLoading(false);
			console.log(err);
			if (err.response) {
				this.snackbar.message = "Unable to process request";
				this.snackbar.color = "error";
				this.snackbar.visible = true;
			}
		},

    async fetchAllSources() {
      var url = endpoints.enquirySources
      var response = await api.call(this.apiEssentials, url)

      if(response) {
        this.sourceItems = response
      }
    },
    
    triggerEditSource(item) {
			this.is_editing = true
			this.addEditSource = Helper.clone(item)
			this.showSourceDialog = true
		},

		triggerDeleteSource(item) {
			this.addEditSource = Helper.clone(item)
			this.showDeleteConfirmation = true
		},

		async deleteSource(confirm) {
			if(confirm) {
				// api call to delete Source
				var url = endpoints.enquirySources + `${this.addEditSource.id}/`
				var response = await api.call(this.apiEssentials, url, api.Methods.DELETE)

				if(response) {
					this.snackbar.message = "Source deleted successfully!";
					this.snackbar.color = "success";
					this.snackbar.visible = true;
					this.showDeleteConfirmation = false
					this.fetchAllSources()
				}
			}
			else{
				this.showDeleteConfirmation = false
			}
		},

    async saveSource() {
      var url = endpoints.enquirySources
			if(this.addEditSource.name) {
				// if editing a tag detail
				if(this.is_editing) {
					url += `${this.addEditSource.id}/`
					var response = await api.call(this.apiEssentials, url, api.Methods.PUT, this.addEditSource)
				}
				// creating new tag
				else {
					response = await api.call(this.apiEssentials, url, api.Methods.POST, this.addEditSource)
				}

				if(response) {
					this.snackbar.message = "Source saved successfully!"
					this.snackbar.visible = true
					this.snackbar.color = "success"
					this.closeSourceDialog()

					this.fetchAllSources()
				}
			}
      else {
        this.snackbar.message = "Source name is required!"
        this.snackbar.visible = true
        this.snackbar.color = "error"
      }
    },

    closeSourceDialog() {
      this.showSourceDialog = false
      this.is_editing = false
      this.$refs.form.reset()
      this.addEditSource = {
        name: null,
        institution: this.currentInstitution.id
      }
    },
  },
  
  created(){
    this.fetchAllSources()
    this.addEditSource.institution = this.currentInstitution.id
  }
}
</script>

<style>
  .responsive-icons {
    /* To keep the icons from breaking */
    min-width: 60px;
  }
</style>